export enum FacebookLocationStatusEnum {
  CONNECTED = 'connected',
  CONNECTING = 'connecting',
  ERROR = 'error',
  NOT_CONNECTED = 'not_connected',
}
